<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 14:03:01
 * @LastEditors: wang.zhiqin wang.zhiqin@trs.com.cn
 * @LastEditTime: 2024-11-20 10:27:12
 * @FilePath: \jsczt\src\views\home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="ydhome">
    <!-- 顶部 -->
    <div class="title">
      <div class="title_logo">
        <img src="../../assets/jscztmb_logo.png" alt="" />
      </div>
      <div class="title_txt">
        <a href="http://www.jiangsu.gov.cn/" target="_blank">江苏省政府 </a>
        |<a href="http://czt.jiangsu.gov.cn/" target="_blank">江苏省财政厅</a> |
        <a href="http://yjsgk.jsczt.cn/yjsgk/list.do" target="_blank">旧站回顾</a>
      </div>
    </div>
    <div style="color: #eb4766;text-align:center;">
      本系统为非涉密系统，严禁处理、传输涉密信息
    </div>
    <!-- 标题 -->
    <div class="cont_text">江苏省预决算公开统一平台</div>
    <!-- 搜索 -->
    <div class="search_box">
      <div class="yearm" @click="changeYear">{{ defaultYear }}</div><div class="line"></div>
      <div class="yearm" @click="show1 = true"> {{defaultXzq}}</div>
      <div class="searchm" @click="search"> <van-icon name="search" style="margin-right: 2px;"/>搜索</div>
    </div>
    <!-- 年份选择 -->
    <van-popup v-model="show" round position="bottom">
      <van-picker show-toolbar  value-key="chnldesc"  :columns="columns" @confirm="confirmYear" @cancel="show = false"/>
    </van-popup>
    <!-- 地域选择 -->
    <van-popup v-model="show1" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="options"
        :field-names="{ text: 'chnldesc', value: 'areacode', children: 'child' }"
        @close="show1 = false"
        @change="handleCascaderChange"
      />
  </van-popup>
    <div class="content">
      <div class="footer_left">
        <div class="footer_title">
          <img src="../../assets/icon.png" />
          <span>预决算公开管理文件</span>
        </div>
        <ul>

          <li v-for="item in yjsData" :key="item.classinfoid" @click="goto('list', item.cname, item.classinfoid,'5')">
            {{ item.cname }}
          </li>
        </ul>
      </div>
      <div class="footer_cent">
        <div class="footer_title">
          <img src="../../assets/icon2.png" />
          <span>政府预决算公开</span>
        </div>
        <ul>
          <li v-for="item in zfyjsData" :key="item.classinfoid" @click="goto('list', item.cname, item.classinfoid,'8')">
            {{ item.cname }}
            <span v-if="item.classinfoid !== 10 &&
              item.classinfoid !== 12 &&
              item.classinfoid !== 24
              " style="margin-left: 10px">|</span>
          </li>
        </ul>
      </div>
      <div class="footer_right">
        <div class="footer_title">
          <img src="../../assets/icon3.png" />
          <span>部门预决算公开</span>
        </div>
        <ul>
          <li v-for="item in bmyjsData" :key="item.classinfoid" @click="goto('list', item.cname, item.classinfoid,'25')">
            {{ item.cname }}
            <span v-if="item.classinfoid !== 29 && item.classinfoid !== 32" style="margin-left: 0px">|</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="footers">
      主办：江苏省财政厅 备案序号：苏ICP备15009401号 公安备案号：32010602010331
      网站标识码：3200000098 江苏省财政厅版权所有
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  components: {},
  data () {
    return {
      defaultYear: '2024',
      defaultXzq: '江苏省',
      cascaderValue: '',
      yjsData: [],
      zfyjsData: [],
      bmyjsData: [],
      show: false,
      show1: false,
      options: [],
      columns: [],
      placeCode:'320000000',
      lastCity:'江苏省'
    }
  },

  watch: {},
  async created () {
    await this.getYear()
    await this.getXzqh()
    await this.getTree()
  },
  mounted () {

  },
  methods: {
    handleCascaderChange(value) {
      this.placeCode=value.value
      let name=value.selectedOptions.map((option) =>  option.chnldesc).join('/')
      this.defaultXzq = name
      let indexLast = this.defaultXzq.lastIndexOf('/'); // 获取最后一个/的位置
      this.lastCity = this.defaultXzq.substring(indexLast + 1); // 截取最后一个/后的值
    },
    changeYear () {
      this.show = true
    },
    confirmYear (e) {
      this.defaultYear = e.chnlname
      this.show = false
      this.getXzqh()
    },
    goto (path, name, classinfoid,num) {
      this.$store.commit('SET_YEAR', this.defaultYear)
      this.$store.commit('SET_PLACE', this.lastCity)
      this.$store.commit('SET_CODE', this.placeCode)
      this.$store.commit('setClassinfoid',classinfoid)
      this.$store.commit('setSjParentid',num)
      this.$router.push({ name: path })
    },
    // 获取年份
    getYear () {
      this.columns = []
      this.$http.get('/api/wcmchannel/findYear').then((res) => {
        this.columns= res.data.data
        this.defaultYear = this.columns[0].chnlname
      })
    },
    // 获取行政区
    async getXzqh () {
      this.options = []
      await this.$http
        .get('/api/wcmchannel/findxzqh', {
          params: {
            year: this.defaultYear,
            openType: 'ys'
          }
        })
        .then((res) => {
          this.options.push(res.data.data)
          this.defaultXzq = this.options[0].chnldesc
        })
    },
    //搜索
    search(){
      this.$store.commit('SET_YEAR', this.defaultYear)
      this.$store.commit('SET_PLACE', this.lastCity)
      this.$store.commit('SET_CODE', this.placeCode)
      this.$store.commit('setClassinfoid',6)
      this.$store.commit('setSjParentid','5')
      this.$router.push({ name: 'list' })
    },
    // 底部部门
    async getTree () {
      await this.$http
        .get('/api/classinfo/getTree', {
          params: {
            topId: '2'
          }
        })
        .then((res) => {
          res.data.data.chlid.forEach((item) => {
            if (item.cname === '预决算公开管理文件') {
              this.yjsData = item.chlid
            }
            if (item.cname === '政府预决算公开') {
              this.zfyjsData = item.chlid
            }
            if (item.cname === '部门预决算公开') {
              this.bmyjsData = item.chlid
            }
          })
        })
    }
  }
}
</script>
<style scoped>
@import url("../../assets/moblie.css");
</style>



// WEBPACK FOOTER //
// src/views/moblie/index.vue